import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ProlongedDialysisLabel = ({ viewBox }) => {
  const { x, y, width, height } = viewBox;
  if ([x, y, width, height].some((val) => val === undefined)) {
    return null;
  }

  const xLeft = x;
  const xRight = x + width;
  const yMid = y + height / 2;
  const head = 6;
  const bodyHeight = 2;
  if (xRight - xLeft <= head * 2) {
    return null;
  }

  const leftHeadPoints = `${xLeft + head},${yMid - head} ${xLeft},${yMid} ${xLeft + head},${yMid + head}`;
  const rightHeadPoints = `${xRight - head},${yMid - head} ${xRight},${yMid} ${xRight - head},${yMid + head}`;

  return (
    <g className="prolonged-dialysis-label">
      <rect
        x={xLeft}
        y={yMid - bodyHeight / 2}
        width={width}
        height={bodyHeight}
      />
      <polygon points={leftHeadPoints} />
      <polygon points={rightHeadPoints} />
    </g>
  );
};

ProlongedDialysisLabel.propTypes = {
  viewBox: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
};

export default memo(ProlongedDialysisLabel);
